var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.816406,
    y: 0.342773,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#1565D8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3499 26.5335C30.4377 27.5337 35.9815 24.9503 39.842 18.818C39.8614 18.7873 39.8791 18.7558 39.8951 18.7236C41.3808 20.3954 42.2833 22.5971 42.2833 25.0096V28.4763C42.2833 31.9799 40.3621 35.1297 37.3839 36.7706C36.9959 36.501 36.5245 36.343 36.0162 36.343C34.6907 36.343 33.6162 37.4175 33.6162 38.743C33.6162 40.0685 34.6907 41.143 36.0162 41.143C36.6875 41.143 37.2944 40.8674 37.73 40.4231C37.081 42.4619 35.1265 43.943 32.8162 43.943C29.9781 43.943 27.6769 41.7078 27.6734 38.9493L28.4322 36.8687C25.35 35.2576 23.3499 32.0512 23.3499 28.4763V26.5335ZM23.3687 24.4088C23.6786 19.4604 27.7901 15.543 32.8166 15.543C34.9351 15.543 36.8911 16.2389 38.4684 17.4145C38.42 17.4644 38.3755 17.5209 38.3359 17.5838C34.8614 23.1028 29.9506 25.3688 23.4617 24.4171C23.4305 24.4125 23.3995 24.4098 23.3687 24.4088ZM25.6972 39.9965C26.2199 43.3627 29.2081 45.943 32.8162 45.943C36.4251 45.943 39.4138 43.3616 39.9355 39.9945L43.7718 40.768C45.2957 41.0653 46.5099 42.2176 46.8864 43.7238L47.9927 48.1489C48.1189 48.6539 47.7371 49.143 47.2166 49.143H18.4166C17.8961 49.143 17.5143 48.6539 17.6405 48.1489L18.7453 43.7296C19.1228 42.2196 20.3419 41.0657 21.8626 40.7732L25.6972 39.9965Z",
    fill: "#DFAD17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0168 39.5424C36.4586 39.5424 36.8168 39.1842 36.8168 38.7424C36.8168 38.3006 36.4586 37.9424 36.0168 37.9424C35.575 37.9424 35.2168 38.3006 35.2168 38.7424C35.2168 39.1842 35.575 39.5424 36.0168 39.5424Z",
    fill: "#DFAD17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7872 23.543H44.0165C45.342 23.543 46.4165 24.6175 46.4165 25.943V29.143C46.4165 30.4685 45.342 31.543 44.0165 31.543H43.4512C43.7341 30.5612 43.8835 29.5307 43.8835 28.4763V25.0096C43.8835 24.5124 43.8508 24.0228 43.7872 23.543Z",
    fill: "#DFAD17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1829 31.543H21.6168C20.2913 31.543 19.2168 30.4685 19.2168 29.143V25.943C19.2168 24.6175 20.2913 23.543 21.6168 23.543H21.8469C21.7833 24.0228 21.7505 24.5124 21.7505 25.0096V28.4763C21.7505 29.5307 21.9 30.5612 22.1829 31.543Z",
    fill: "#DFAD17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.1ccb82f1d88a3b2ace664fd0b5e28a3f.svg";
export { ForwardRef as ReactComponent };